import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import Image from '@base/Image';
import { mediaQuery } from '@styles/index';

const ImageContainer = styled.div`
  position: absolute;
  z-index: -1;
  top: 0;
  left: ${({ $clearLeftMargin }) => ($clearLeftMargin ? 0 : -48)}px;
  ${mediaQuery.uptoTablet} {
    left: calc(50vw - 37.5px);
    width: 75px;
    height: 60px;
  }
`;

export default function BackgroundImage({ className, clearLeftMargin }) {
  const [width, setWidth] = useState(160);
  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);
  return (
    <ImageContainer $clearLeftMargin={clearLeftMargin}>
      <Image
        src="about/quote.png"
        alt="quotes"
        $width={width}
        className={className}
        height={98}
        width={120}
      />
    </ImageContainer>
  );
}

BackgroundImage.defaultProps = {
  className: '',
  clearLeftMargin: false
};

BackgroundImage.propTypes = {
  className: PropTypes.string,
  clearLeftMargin: PropTypes.bool
};
